import { render } from "./DetalleInspeccionView.vue?vue&type=template&id=2f4dc037"
import script from "./DetalleInspeccionView.vue?vue&type=script&lang=js"
export * from "./DetalleInspeccionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__